import React, { useEffect, useState } from "react";

export const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = useState(mediaMatch.matches);

    useEffect(() => {
        const handler = (e) => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });
    return matches;
};

export const useMediumScreen = () => useMediaQuery("(min-width: 768px)");
export const useSmallScreen = () => useMediaQuery("(min-width: 640px)");
